/*
 * @Author: changcheng
 * @LastEditTime: 2023-11-06 13:48:36
 */
import { useState } from "react";
import { getTrainCourseList, querySubjectTree } from "@root/common/service";
import { Tabs, Pagination, Carousel, Select } from "antd";
import CourseList from "@root/components/courselist";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@root/store/index";
import { handleTreelData } from "@root/common/utils";
import "./_style.scss";
const { TabPane } = Tabs;
const pageSize = 12;
export default function SubjectCourse() {
  const [total, setTotal] = useState(1);
  const [searchParam, setSearchParam] = useState<{
    subjectIdList: any[];
    centerCategoryIdList: any[];
    courseLevelType: number;
    courseOrderType: number;
  }>({
    subjectIdList: [], //学科列表
    centerCategoryIdList: [], // 中心列表
    courseLevelType: 111, //课程级别
    courseOrderType: 1, //排序类型
  });
  const { publicSearchKey } = useSelector((state: RootState) => state.userInfo);
  const [courseList, setCourseList] = useState([]);
  // 中心分类
  const [subjectTree, setSubjectTree] = useState([]);
  const [subjectSecondTree, setSubjectSecondTree] = useState([]);
  const [subjectThreeTree, setSubjectThreeTree] = useState([]);
  // 所选学科类型
  const [selectSubjectId, setSelectSubjectId] = useState(["", "", ""]);
  const { xy_navigation } = useSelector(
    (item: RootState) => item.advertisementData
  );
  // 获取培训课程
  const queryTrainCourseList = async (param: any, page = 1) => {
    param.subjectIdList = [selectSubjectId.filter(Boolean).pop()];
    const {
      data: { rows, total },
    } = await getTrainCourseList(param, {
      pageNum: page,
      pageSize,
    });
    setCourseList(rows);
    setTotal(total);
  };
  useEffect(() => {
    queryTrainCourseList(searchParam);
  }, [searchParam, selectSubjectId]);
  useEffect(() => {
    queryTrainCourseList({
      searchValue: publicSearchKey,
    });
  }, [publicSearchKey]);
  // 排序搜索
  const onChange = (key: string) => {
    queryTrainCourseList({
      ...searchParam,
      courseOrderType: key,
    });
  };
  /**
   * 获取中心分类
   */
  const getSubjectTree = async () => {
    const { data } = await querySubjectTree();
    setSubjectTree(handleTreelData(data));
  };
  useEffect(() => {
    getSubjectTree();
  }, []);
  const defalutOptions = [
    {
      value: "",
      label: "请选择",
    },
  ];
  return (
    <div className="course_train">
      <Carousel
        autoplay
        autoplaySpeed={2000}
        dots={{ className: "banner-custom-dots" }}
      >
        {xy_navigation.length > 0 &&
          xy_navigation.map((bannerItem: any) => {
            return (
              <div
                className="banner-item"
                onClick={async () => {
                  bannerItem.url && window.open(bannerItem.url);
                }}
              >
                <img
                  src={bannerItem.imageUrl}
                  alt=""
                  height={"150px"}
                  width={"100%"}
                />
              </div>
            );
          })}
      </Carousel>
      <div className="select_subject">
        <h3>选择学科：</h3>
        <Select
          defaultValue={subjectTree}
          style={{ width: 200 }}
          options={[
            ...defalutOptions,
            ...subjectTree.map((item: any) => ({
              label: item.label,
              value: item.value,
            })),
          ]}
          onChange={(index: any) => {
            setSelectSubjectId([index, "", ""]);
            const item = subjectTree.filter((it: any) => it.value === index);
            //@ts-ignore
            setSubjectSecondTree(item[0].children);
          }}
          value={[selectSubjectId[0]]}
        />
        <Select
          defaultValue={subjectSecondTree as any}
          style={{ width: 200, marginLeft: "10px" }}
          options={[
            ...defalutOptions,
            ...subjectSecondTree.map((item: any) => ({
              label: item.label,
              value: item.value,
            })),
          ]}
          value={[selectSubjectId[1]]}
          onChange={(index: any) => {
            setSubjectThreeTree([]);
            const item = subjectSecondTree.filter(
              (it: any) => it.value === index
            );
            setSelectSubjectId([selectSubjectId[0], index, ""]);
            setSubjectThreeTree(
              //@ts-ignore
              item[0].children
            );
          }}
        />
        <Select
          defaultValue={subjectThreeTree}
          style={{ width: 200, marginLeft: "10px" }}
          options={[
            ...defalutOptions,
            ...subjectThreeTree.map((item: any) => ({
              label: item.label,
              value: item.value,
            })),
          ]}
          value={[selectSubjectId[2]]}
          onChange={(index: any) => {
            selectSubjectId[2] = index;
            setSelectSubjectId([...selectSubjectId]);
          }}
        />
      </div>
      <div>
        <Tabs defaultActiveKey="1" onChange={onChange}>
          <TabPane tab="综合" key="1">
            <CourseList data={courseList} />
          </TabPane>
          <TabPane tab="最新" key="2">
            <CourseList data={courseList} />
          </TabPane>
          <TabPane tab="最热" key="3">
            <CourseList data={courseList} />
          </TabPane>
        </Tabs>
        <div className="home_page_container">
          <Pagination
            defaultCurrent={1}
            total={total}
            pageSize={12}
            onChange={(page) => {
              queryTrainCourseList(searchParam, page);
            }}
            showSizeChanger={false}
          />
        </div>
      </div>
    </div>
  );
}
